import { render, staticRenderFns } from "./User_profile.vue?vue&type=template&id=060a526d&scoped=true&"
import script from "./User_profile.vue?vue&type=script&lang=js&"
export * from "./User_profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a526d",
  null
  
)

export default component.exports